module.exports = __webpack_public_path__ + "static/img/IMG_20240208_155425.e5aa9db8.jpg";